import React, { useEffect, useState, useRef } from 'react';
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SideEditBar from "../components/SideEditBar"
import axios from 'axios';
import { GetUserRole } from '../services/UserRole';
import { Edit, Menu } from "@mui/icons-material";
import toast from 'react-hot-toast';
import { Url } from '../services/Constants';
import { setHeader } from '../services/Headers';
import ProfileTile from '../components/ProfileTile';
import { useNavigate, useParams } from 'react-router-dom';
import OrderHistory from '../components/OrderHistory';
import OrderDetails from "../components/OrderDetails"
import { Getauth } from '../services/Auth';
import { Oval } from 'react-loader-spinner';

export default function Profile() {
  
  const Navigate = useNavigate()

  const initialProfileData = useRef({
    firstName: '',
    lastName: '',
    email: '',
    mobile_number: '',
    role: '',
    profile_pic: '',
  });

  const {id} = useParams()
  const [profileData, setProfileData] = useState(initialProfileData);
  const [profilepic,setProfilepic] = useState(null)
  const [userAddress, setUserAddress] = useState()
  const [isMenu,setIsMenu] = useState(false)
  const [feedStates,setFeedStates] = useState("profile")
  const [orderDetails, setOrderDetails] = useState()
  const [isloader, setIsloader] = useState(false)



  useEffect(() => {
    const userProfileCheck = async () => {
      const role = GetUserRole();
      const endpoint = role === "buyer" ? `${Url}/buyer/get_profile` : `${Url}/seller/get_profile`;
      
      try {
        const result = await axios.get(endpoint, setHeader());
        const data = result.data;
        if (data.response_code === 200) {
          const fullName = data.response_data.name.split(' ');
          const firstName = fullName[0];
          const lastName = fullName.slice(1).join(' ');


          setProfileData({...data.response_data,firstName,lastName,role});
        }else{
          Navigate("/")
        }
      } catch (error) {
        console.log(error);
        Navigate("/")
      } 
    };

    const getuserAddress = async() =>{
      const role = GetUserRole();
      if(role==="buyer"){
        try {
          const result = await axios.get(`${Url}/buyer/addresses`,setHeader())
          if(result.data.response_code===200){
            setUserAddress(result.data.response_data.addresses[0])
          }
          else{
            setUserAddress(null)
          }
        } catch (error) {
          console.log(error)
        }
      }
  }


  userProfileCheck();
  getuserAddress()
  }, [profilepic]);

  

  useEffect(()=>{  
    if(id==="order-history"){
      setIsloader(true)
      setFeedStates(id)
    }

    if(feedStates==="order-history"){
      setIsloader(false)
    }

  },[])

  useEffect(()=>{
    if(feedStates==="order-history"){
      setIsloader(false)
    }
  },[feedStates])



  const disableHande =()=>{
    toast.error("Please Enter Pincode!")
  }

  
  const profilepicHandle = (pic) => {
    setProfilepic(pic);
    setProfileData(prevData => ({
      ...prevData,
      profile_pic: pic
    }));
  }

 const feedHandle = (data)=>{
    setIsloader(true)
    setFeedStates(data)
    setIsloader(false)
    setIsMenu(false)
 }

 const orderData = (data)=>{
    setOrderDetails(data)
 }


  const updateProfileData = (newData) => {
    setProfileData(prevData => ({
        ...prevData,
        ...newData
    }));
  };



  

  return (
    <div className='Profile-container '>
      <Navbar  profilePic={profilepic}/>
      <div className="profile flex min-h-screen ">
      {isMenu?<div className="sidebar w-[20%] relative -left-5 mt-2 mr-2 max-2xl:w-[25%] max-lg:absolute max-lg:z-0 max-lg:w-[40%] max-sm:w-[70%] max-sm:mr-0">
      <span className="invisible absolute cursor-pointer right-2 z-30 text-3xl md:top-3 font-semibold max-sm:right-4 max-sm:top-3 max-lg:visible" onClick={()=>setIsMenu(!isMenu)}>x</span>
      <SideEditBar profileData={profileData} profilepics={profilepicHandle} feedHandle={feedHandle}/>
      </div>:<div className="sidebar w-[20%] mr-2 top-5 max-2xl:w-[25%] max-lg:absolute max-lg:hidden max-lg:z-10 max-lg:w-[40%] max-sm:w-[70%] max-sm:mr-0">
      <SideEditBar profileData={profileData} profilepics={profilepicHandle} feedHandle={feedHandle}/>
      </div>}
      <div className="profiletile w-[75%]  max-lg:w-[95%] max-lg:mx-auto ">
      <Menu className="invisible menu max-lg:visible" onClick={()=>setIsMenu(!isMenu)}/>
      {feedStates==="profile"?<ProfileTile profileData={profileData} userAddress={userAddress} profilepics={profilepic} updateProfileData={updateProfileData} className=""/>:feedStates!=="orderdetail"?
      <OrderHistory feedHandle={feedHandle} orderData={orderData} />:<OrderDetails data={orderDetails}/>
      }
      
        {isloader?<div className='fixed inset-0 z-50 bg-gray-200 bg-opacity-50 flex justify-center items-center'>
                <Oval
                visible={true}
                height="80"
                width="80"
                color="#995500"
                ariaLabel="oval-loading"
                wrapperStyle={{}}
                wrapperClass=""
                secondaryColor='none'
                strokeWidth={3}
                />
                </div>:""}

      
      </div>
      </div>
      <div className=" w-full bottom-0 ">
      <Footer />
      </div>
    </div>
  );
}